export default "__VITE_ASSET__zxijmo9y__"